import React from "react";

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const header = React.Children.toArray(children).find(
    (child) => child.type === Modal.Header
  );
  const body = React.Children.toArray(children).find(
    (child) => child.type === Modal.Body
  );
  const footer = React.Children.toArray(children).find(
    (child) => child.type === Modal.Footer
  );

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-lg shadow-lg min-w-[300px] max-w-[90vw] min-h-[300px] max-h-[90vh] flex flex-col">
        {header && (
          <div className="px-4 border-b border-gray-200">{header}</div>
        )}
        <div className="flex-grow overflow-y-auto px-4 pb-4">{body}</div>
        {footer && (
          <div className="px-4 border-t border-gray-200">{footer}</div>
        )}
      </div>
    </div>
  );
};

Modal.Header = ({ children }) => <>{children}</>;

Modal.Body = ({ children }) => <>{children}</>;

Modal.Footer = ({ children }) => <>{children}</>;

export default Modal;
